

























import {Vue, Component, PropSync, Prop} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import {ClaimType, Mall} from 'supporter';
import CompSelectBox from '@/components/common/CompSelectBox.vue';

@Component({
  components: {
    CompSelectBox
  }
})
export default class ShippingAreaTypeSelect extends Vue{
  @Getter('mall/malls')
  private malls: Mall[]

  @Prop({required: true})
  private readonly searchFormType!: ClaimType

  @PropSync('shippingAreaType')
  private shippingAreaTypeSync!: '' | boolean;

  @PropSync('includesHoldDelivery')
  private includesHoldDeliverySync!: boolean;

  @PropSync('returnWayType')
  private returnWayTypeSync!: undefined | number;

  private shippingAreaTypes = [
    {value: 'PARTNER_SHIPPING_AREA', name: 'ORDER_ORDER_CONTENT_TOP_SHIPPING_AREA_TYPE_PARTNER_SHIPPING_AREA'},
    {value: 'MALL_SHIPPING_AREA', name: 'ORDER_ORDER_CONTENT_TOP_SHIPPING_AREA_TYPE_MALL_SHIPPING_AREA'}
  ];

  private returnWayTypes = [
    {value: '', name: 'ORDER_ORDER_CONTENT_TOP_RETURN_WAY_TYPE_ALL'},
    {value: 'SELLER_COLLECT', name: 'ORDER_ORDER_CONTENT_TOP_RETURN_WAY_TYPE_SELLER_COLLECT'},
    {value: 'BUYER_DIRECT_RETURN', name: 'ORDER_ORDER_CONTENT_TOP_RETURN_WAY_TYPE_BUYER_DIRECT_RETURN'}
  ];

  private showIncludeHoldDelivery = this.searchFormType === 'CANCEL' || this.searchFormType === 'EXCHANGE';
  private showReturnWay = this.searchFormType === 'RETURN';

}
